import {DatabaseCode, toDatabaseCode} from "./database-code";

export type NoticeCategory = DatabaseCode;

const general: NoticeCategory = {
  code: "GENERAL",
  displayValue: {
    id: "common.entity.noticecategory.general",
    defaultMessage: "General",
  },
};

const operations: NoticeCategory = {
  code: "OPERATIONS",
  displayValue: {
    id: "common.entity.noticecategory.operations",
    defaultMessage: "Operations",
  },
};

const weather: NoticeCategory = {
  code: "WEATHER",
  displayValue: {
    id: "common.entity.noticecategory.weather",
    defaultMessage: "Weather",
  },
};

const safety: NoticeCategory = {
  code: "SAFETY",
  displayValue: {
    id: "common.entity.noticecategory.safety",
    defaultMessage: "Safety",
  },
};

const outage: NoticeCategory = {
  code: "OUTAGE",
  displayValue: {
    id: "common.entity.noticecategory.outage",
    defaultMessage: "Outage",
  },
};

const maintenance: NoticeCategory = {
  code: "MAINTENANCE",
  displayValue: {
    id: "common.entity.noticecategory.maintenance",
    defaultMessage: "Maintenance",
  },
};

export const noticeCategory = {
  general,
  operations,
  weather,
  safety,
  outage,
  maintenance,
};

export const noticeCategories = Object.values(noticeCategory);

export const toNoticeCategory = (code: string): NoticeCategory =>
  toDatabaseCode(code, noticeCategories);

export const toNoticeCategorySafely = (
  code: string | undefined
): NoticeCategory | undefined =>
  code ? toDatabaseCode(code, noticeCategories) : undefined;
